import { useTranslation } from 'react-i18next';
import { computeTimeAgo } from '../utils/computeTimeAgo';

const FALLBACK = {
  just_now: 'just now',
  seconds: '{{count}} sec ago',
  minutes: '{{count}} min ago',
  hours: '{{count}} h ago',
  days: '{{count}} d ago',
} as const;

export const useTimeAgo = (isoDate: string): string => {
  const { t } = useTranslation();
  const { unit, count } = computeTimeAgo(isoDate);

  if (unit === 'just_now') {
    return t('top_wins.time_ago.just_now', FALLBACK.just_now);
  }

  return t(`top_wins.time_ago.${unit}`, FALLBACK[unit], { count });
};
